export default "__VITE_ASSET__ec877f67__"